import { render, staticRenderFns } from "./CenterProgramExtension.vue?vue&type=template&id=83d5b8e4&"
import script from "./CenterProgramExtension.vue?vue&type=script&lang=js&"
export * from "./CenterProgramExtension.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports